// extracted by mini-css-extract-plugin
export default {"errorContainer":"ResearchMediaError_errorContainer__LN30Q","root":"ResearchMediaError_root__4RxK5","withText":"ResearchMediaError_withText__L9B+Z"};